import React from 'react';
import '../../styles/home/StatsBar.css';

interface Stat {
  value: string;
  label: string;
}

const stats: Stat[] = [
  { value: '500+', label: 'Active Partners' },
  { value: '12K+', label: 'Products Distributed' },
  { value: '98.5%', label: 'On-Time Delivery' },
  { value: '24/7', label: 'Support Available' },
];

const StatsBar: React.FC = () => {
  return (
    <section className="stats-bar">
      <div className="stats-bar__container">
        {stats.map((stat, index) => (
          <React.Fragment key={stat.label}>
            <div className="stats-bar__item">
              <span className="stats-bar__value">{stat.value}</span>
              <span className="stats-bar__label">{stat.label}</span>
            </div>
            {index < stats.length - 1 && (
              <div className="stats-bar__divider" aria-hidden="true" />
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default StatsBar;
